import * as actionTypes from "./actionTypes";

export const sendMessage = (payload) => {
  return {
    type: actionTypes.SEND_MESSAGE,
    payload,
  };
};
